import * as React from "react";
import { useEffect, useReducer, useRef, useState } from 'react';
import { Spinner, Button, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import EmptySpace from './EmptySpace';
import NewsEventListing from './NewsEventListing';
import MediaListing from './MediaListing';
import InvestorNewsPage from './InvestorNewsPage';


type Props = {
    newsPath: string;
    newsTabTitle: string;

    mediaPath: string;
    mediaTabTitle: string;

    pressReleasePath: string;
    pressReleaseTabTitle: string;
}

type SiteSearchPageState = {
    activeTab: 'news' | 'media' | 'pressRelease';
}

const initialState: SiteSearchPageState = {
    activeTab: 'pressRelease'
}

const getUrlVars = (paramName) => {

    let urlParams = window.location.hash || '';
    if (urlParams.length > 2 && urlParams[0])
        urlParams = urlParams.substr(1);
    
    const searchParams = new URLSearchParams(urlParams);
    return searchParams.get(paramName);
}

const NewsPressMediaListing = (props: Props) => {

    const getInitialState = () => {
        //var defaultSearchType = searchTypes.find((x) => x.value == (props.deafultSearchType || ''));

        let result = initialState;
        let urlTab = getUrlVars('tab');
        if (urlTab == "news" || urlTab == "media") {
            result.activeTab = urlTab;
        }        

        //console.log('getInitialState', result);

        return result;
    };

    const [state, setState] = useReducer(
        (prevState: SiteSearchPageState, newState: Partial<SiteSearchPageState>) => ({ ...prevState, ...newState }),
        getInitialState()
    );

    return (
        <>
            <div className="container">
                <Nav pills>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: state.activeTab === 'pressRelease' })}
                            onClick={() => {
                                window.history.pushState({}, '', '?tab=pressRelease');
                                setState({ activeTab: 'pressRelease' })
                            }}
                            href="#"
                        >
                            {props.pressReleaseTabTitle}
                        </NavLink>
                    </NavItem>                    
                    <NavItem>
                        <NavLink
                            className={classnames({ active: state.activeTab === 'news' })}
                            onClick={() => {
                                window.history.pushState({}, '', '?tab=news');
                                setState({ activeTab: 'news' })
                            }}
                            href="#"
                        >
                            {props.newsTabTitle}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: state.activeTab === 'media' })}
                            onClick={() => {
                                window.history.pushState({}, '', '?tab=media');
                                setState({ activeTab: 'media' })
                            }}
                            href="#"
                        >
                            {props.mediaTabTitle}
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <TabContent activeTab={state.activeTab}>
                <TabPane tabId="pressRelease">
                    <InvestorNewsPage
                        active={state.activeTab === 'pressRelease'}                        
                        path={props.pressReleasePath}
                    />
                </TabPane>
                <TabPane tabId="media">
                    <MediaListing
                        active={state.activeTab === 'media'}
                        path={props.mediaPath}
                        culture={"en-us"}
                    />
                </TabPane>
                <TabPane tabId="news">
                    <NewsEventListing
                        active={state.activeTab === 'news'}
                        path={props.newsPath}
                    />
                </TabPane>
            </TabContent>
        </>
    )
}

export default NewsPressMediaListing;